import styled from 'styled-components';
import { flexPosition, fontStyle } from '../../styles/mixins';
import {
  GRAY_DARKER,
  FONT_WEIGHT_BOLD,
  GRAY_MEDIUM,
  FONT_SIZE_7,
  FONT_WEIGHT_NORMAL,
  FONT_SIZE_6,
  INFO_COLOR,
  FONT_SIZE_5,
  GRAY_LIGHTER,
  DANGER_COLOR,
} from '../../styles/variables';
import AlertIcon from '../../images/icon-warning.svg';
import { StyledFormGroup as FormGroup } from '../VariationOptionForm/style';
import { RadioContainer } from '../Radio/style';
import { Input } from '../Input/style';

export const Container = styled.div`
  ${flexPosition({ justify: 'space-between' })};
  height: 100%;
  flex-direction: row;
`;

export const Content = styled.div`
  ${flexPosition({ justify: 'space-between' })};
  flex-direction: column;
  height: 642px;
  padding: ${({ left }) => (left ? '20px 10px 25px 20px' : '20px 20px 25px 10px')};
  width: 50%;
`;

export const Header = styled.div`
  label {
    margin-left: 10px;
    ${fontStyle(GRAY_DARKER, FONT_SIZE_7, FONT_WEIGHT_BOLD)};
    margin-bottom: 0px;
  }

  ${Input} {
    height: 25px;
    margin-left: 10px;
    padding-right: 0px;
    ::placeholder {
      ${fontStyle(INFO_COLOR, FONT_SIZE_5, FONT_WEIGHT_BOLD)};
    }
  }

  div {
    padding: 0px;
    justify-content: space-between;
  }

  header {
    margin-bottom: 10px;

    .btn-edit-title,
    .btn-close-edit-title {
      height: 28px;
    }

    svg {
      height: 25px;
    }
  }
`;

export const VariationOptionFormContent = styled.div`
  width: 100%;
  height: auto;
`;

export const ContentContainer = styled.div`
  border: 1px solid ${GRAY_LIGHTER};
  border-radius: 3px;
  display: flex;
  margin-bottom: 15px;
  padding: 20px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const StyledFormGroup = styled(FormGroup)`
  flex-shrink: ${({ small }) => (small ? '0' : '1')};
  margin-bottom: 0;
  margin-right: ${({ small }) => (small ? '20px' : '0')};
  width: ${({ small }) => (small ? '140px' : '100%')};

  > input {
    height: 40px;
  }
`;

export const SelectionOption = styled(ContentContainer)`
  flex-direction: column;
  height: 247px;
  justify-content: space-between;
`;

export const StyledInput = styled(Input)`
  height: 35px;
  margin: 0px 5px;
  width: 45px;

  :disabled {
    background: #fff;
    border: 1px solid ${GRAY_LIGHTER};
  }
`;

export const textInfo = styled.div`
  ${flexPosition({})};
  flex-direction: column;
  margin-left: ${props => (props.firstBar ? '38px' : '30px')};

  span {
    ${fontStyle(GRAY_MEDIUM, FONT_SIZE_7, FONT_WEIGHT_NORMAL)};
  }
`;

export const PriceType = styled(ContentContainer)`
  flex-direction: column;
  height: 216px;
  justify-content: space-between;

  ${StyledInput} + span {
    background-color: ${props => (props.blocked ? GRAY_LIGHTER : '')};
    cursor: ${props => (props.blocked ? 'inherit' : '')};
  }
`;

export const MinMaxContainer = styled.div`
  position: relative;
`;

export const RadioSelectionContainer = styled.div`
  ${RadioContainer} {
    align-items: center;
    height: 35px;
    margin-top: 10px;
  }
`;

export const RadioPriceContainer = styled.div``;

export const RadioBar = styled.div`
  ${flexPosition({ align: 'center' })};

  & + & {
    border-top: 1px solid ${GRAY_LIGHTER};
    margin-top: 15px;
    padding-top: 15px;
  }

  ${RadioContainer} {
    margin-top: 0px;
  }
`;

export const MinMaxBar = styled.div`
  ${fontStyle(GRAY_DARKER, FONT_SIZE_7, FONT_WEIGHT_BOLD)};
  margin-left: 28px;
  top: 0;
  position: absolute;
  width: auto;

  ${StyledFormGroup} {
    > ${Input} {
      height: 35px;
      width: 45px;
    }
  }
`;

export const ErrorIcon = styled.span`
  width: 20px;
  height: 20px;
  margin-right: 10px;
  display: block;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url(${AlertIcon});
`;

export const ErrorMessage = styled.div`
  ${flexPosition({ align: 'center', justify: 'center' })}
  ${fontStyle('#FFF', FONT_SIZE_6, FONT_WEIGHT_NORMAL)}
  border-radius: 3px;
  margin-top: 14px;
  padding: 12px;
  background-color: ${DANGER_COLOR};
  text-align: center;
`;

export const Footer = styled.div`
  ${flexPosition({ align: 'center', justify: 'space-between' })}
  margin-top: 10px;
  width: 100%;
`;

// Styles
export const labelStyles = {
  lineHeight: '22px',
  marginBottom: '8px',
};

export const descStyles = {
  marginBottom: 0,
  fontWeight: FONT_WEIGHT_BOLD,
  fontSize: FONT_SIZE_7,
  width: '375px',
};

export const radioCustomDescStyles = {
  flexDirection: 'row',
  span: {
    fontSize: FONT_SIZE_7,
    fontWeight: FONT_WEIGHT_BOLD,
  },
  'span:last-of-type': {
    marginLeft: '5px',
  },
};



// WEBPACK FOOTER //
// ./src/components/CreateVariationModal/style.js